import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { DataGridNumberPercentChangeComboCell } from "~/components/DataGrid/DataGridNumberPercentChangeComboCell";
import { AssetTableRowData } from "../types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

export const TRAILING_7_DAY_TRANSFER_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.trailing7DayTransferCount,
    label: "Weekly Transfer Count",
    tooltip: CatalogMetricSlugs.trailing_7_day_transfer_count,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.trailing7DayTransferCount,
    width: 180,
    render: (item) => {
        const measure = getMeasureValue(item, "trailing_7_day_transfer_count");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const WEEKLY_TRANSFER_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.weeklyTransferCount,
    label: "Weekly Transfer Count",
    tooltip: CatalogMetricSlugs.weekly_transfer_count,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.weeklyTransferCount,
    width: 180,
    render: (item) => {
        const measure = getMeasureValue(item, "weekly_transfer_count");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const TRAILING_30_DAY_TRANSFER_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.trailing30DayTransferCount,
    label: (
        <>
            Monthly
            <br />
            Transfer Count
        </>
    ),
    tooltip: CatalogMetricSlugs.trailing_30_day_transfer_count,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.trailing30DayTransferCount,
    width: 170,
    loginRequired: true,
    render: (item) => {
        const measure = getMeasureValue(item, "trailing_30_day_transfer_count");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const MONTHLY_TRANSFER_COUNT_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.monthlyTransferCount,
    label: "Monthly Transfer Count",
    tooltip: CatalogMetricSlugs.monthly_transfer_count,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.monthlyTransferCount,
    width: 180,
    render: (item) => {
        const measure = getMeasureValue(item, "monthly_transfer_count");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};
